/**
 * @author he jia
 * @date 2025-05-20
 * @description 项目完善信息
 */

import { baseURL } from '@/httpService/API';
import { hMacAjax as fetch } from 'grt-tool-lib-front';
let reqUrl = baseURL + '/grt-user-center-service',
    //  systemUrl = baseURL + '/apaas-system-service',
    url = {
        needVerify: '/user/student/v1/project/improve/verify',
        detail: '/user/student/v1/project/improve/detail',
        save: '/user/student/v1/project/improve',
        config: '/business-improve/student/v1/config',
        allArea: '/open/geo/v1/all'
    };
// 判断是否需要完善信息
export const isBusinessNeedVerify = (data) => {
    return fetch.get(`${reqUrl}${url.needVerify}`, data);
};

// 获取完善信息详情
export const getImproveInformationDetail = (data) => {
    return fetch.get(`${reqUrl}${url.detail}`, data);
};

// 保存完善信息
export const saveImproveInformation = (data) => {
    return fetch.post(`${reqUrl}${url.save}`, data);
};

// 项目个人完善信息配置校验是否开启
export const getImproveInformationConfig = (data) => {
    return fetch.get(`${reqUrl}${url.config}`, data);
};

// 获取所有地区
export const getAllArea = () => {
    return fetch.get(`${reqUrl}${url.allArea}`);
};
